import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SutrapathComponent } from './sutrapath.component';
import { AccordionModule } from '../accordion/accordion.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    SutrapathComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AccordionModule
  ]
})
export class SutrapathModule { }
